export const gizlilikPolitikasi = {
  title: 'Gizlilik Politikası',
  sections: [
    {
      heading: '1. Toplanan Bilgiler',
      paragraphs: [
        'YolSepetiGO olarak, hizmetlerimizi sunabilmek için aşağıdaki kişisel verileri toplayabiliriz:',
      ],
      list: [
        'Ad, soyad ve iletişim bilgileri',
        'Konum bilgisi (hizmet sağlamak amacıyla)',
        'Araç bilgileri',
        'Ödeme bilgileri',
        'Uygulama kullanım verileri',
      ],
    },
    {
      heading: '2. Bilgilerin Kullanımı',
      paragraphs: [
        'Toplanan bilgiler yalnızca hizmet sunumu, müşteri desteği, hizmet kalitesinin iyileştirilmesi ve yasal yükümlülüklerin yerine getirilmesi amacıyla kullanılmaktadır.',
      ],
    },
    {
      heading: '3. Bilgi Güvenliği',
      paragraphs: [
        'Kişisel verileriniz, endüstri standardı güvenlik önlemleri ile korunmaktadır. Verileriniz üçüncü şahıslarla izniniz olmadan paylaşılmaz.',
      ],
    },
    {
      heading: '4. Çerezler',
      paragraphs: [
        'Web sitemiz ve uygulamamız, kullanıcı deneyimini iyileştirmek amacıyla çerezler kullanmaktadır. Tarayıcı ayarlarınızdan çerez tercihlerinizi yönetebilirsiniz.',
      ],
    },
  ],
};
